import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-auction-ended-pop-up',
  templateUrl: './auction-ended-pop-up.component.html',
  styles: [
  ]
})
export class AuctionEndedPopUpComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AuctionEndedPopUpComponent>) {

  }

  ngOnInit(): void {

  }



}
